<template>
    <form action="">
        <h2 class="color__dark_blue">{{ get_translation_constant('calculator_block_title') }}</h2>
        <div class="calculator__block_header">
            <ul class="nav nav-tabs" id="calculatorTab" role="tablist">
                <li class="nav-item">
                    <a aria-controls="weight" aria-selected="true" class="nav-link active"
                       data-bs-toggle="tab"
                       href="#weight" id="weight-tab"
                       role="tab">{{ get_translation_constant('calculator_block_tab_weight') }}</a>
                </li>
                <!-- href="#product" -->
                <li class="nav-item">
                    <a aria-controls="product" aria-selected="false" class="nav-link" data-bs-toggle="tab"
                       href="javascript:void(0)"
                       id="product-tab" role="tab">{{ get_translation_constant('calculator_block_tab_product') }}</a>
                </li>
                <li class="nav-item" v-show="!expanded">
                    <a class="nav-link with__arrow"
                       :href="ratesurl">{{ get_translation_constant('calculator_block_tab_expand') }}</a>
                </li>
            </ul>
            <div class="calculator__block_header_info">
                <div>{{ get_translation_constant('calculator_block_text_up_to_kg') }}
                    <strong>{{ get_translation_constant('calculator_block_text_to_currency_kg') }}</strong>
                    <span class="tooltip__block tooltip__bottom">
                        <span class="tooltip__block_trigger">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M8 16c4.37 0 8-3.62 8-8 0-4.37-3.64-8-8-8-4.38 0-8 3.63-8 8 0 4.38 3.62 8 8 8Zm0-1.33A6.63 6.63 0 0 1 1.34 8 6.66 6.66 0 1 1 8 14.67ZM7.93 5.2c.57 0 1.02-.46 1.02-1.02 0-.57-.45-1.03-1.02-1.03-.57 0-1.02.46-1.02 1.03 0 .56.45 1.02 1.02 1.02Zm-1.31 7.1h3.2c.32 0 .57-.22.57-.55 0-.3-.25-.54-.57-.54h-.97v-4c0-.42-.22-.7-.61-.7H6.75a.55.55 0 0 0-.56.55c0 .32.25.55.56.55h.85v3.6h-.98a.55.55 0 0 0-.57.54c0 .33.26.55.57.55Z"
                                  fill="#000"/>
                            </svg>
                        </span>
                        <span class="tooltip__block_inner">
                        <pre>{{ deliverypricesummary }}</pre>
                        </span>
                    </span>
                </div>
            </div>
            <div class="tab-content" id="calculatorTabContent">
                <div aria-labelledby="weight-tab" class="tab-pane fade show active" id="weight"
                     role="tabpanel">
                    <div class="form__col calculator__block_input">
                        <input ref="weight_calc_value" @input="setSlide()" @change="setSlide()"
                               class="form__control type_float" type="number" autocomplete="off" v-model="weight">
                        <label for="weight_calc_value">{{
                                get_translation_constant('calculator_block_text_weight_kg')
                            }}</label>
                        <input ref="weight_calc" class="form__control" type="text"/>

                        <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                        fill="#000000"></path>
                                </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner">
                                    <pre>{{ deliverypricesummary }}</pre>
                                </span>
                            </span>
                        </span>
                    </div>
                    <div class="row justify-content-end" v-if="!expanded ">
                        <div
                            class="col-12 text-right total__price d-flex align-items-center justify-content-between justify-content-lg-end">
                            {{ get_translation_constant('calculator_block_delivery_price') }}
                            <span>{{ calculatedPriceByWeight }}</span>
                        </div>
                    </div>
                    <div class="size_calculator" v-if="!!expanded">
                        <div class="checkbox__custom h_text_small with__line mb-3">
                            <span>
                                <input id="size_calculator" name="size_calculator" type="checkbox" v-model="calcBySize">
                                <label for="size_calculator">
                                    <strong>{{
                                            get_translation_constant('calculator_block_text_weight_calculation')
                                        }}</strong>
                                    <span class="tooltip__block tooltip__bottom tooltip__modal">
                                        <span class="tooltip__block_trigger">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                                    fill="#515154"></path>
                                            </svg>
                                        </span>
                                        <span class="tooltip__block_overlay">
                                            <span class="tooltip__block_inner">
                                                <span class="tooltip__block_close"></span>
                                                <p>{{
                                                        get_translation_constant('calculator_block_text_fill_all_sections')
                                                    }}</p>
                                            </span>
                                        </span>
                                    </span>
                                </label>
                            </span>
                        </div>

                        <div class="form__col">
                            <div
                                class="row small-gutters justify-content-center justify-content-xl-between align-items-center flex-xl-nowrap">
                                <div class="col-4 col-xl-auto pe-xl-0">
                                    <input class="form__control w-160 type_float" @input="checkDimensions()"
                                           @change="checkDimensions()" type="number" v-model="dimensions.length"
                                           id="length" name="length"
                                           :placeholder="get_translation_constant('calculator_block_text_length_cents')"
                                           :disabled="isDisabled"
                                    >
                                </div>
                                <div class="col-auto px-0 d-none d-xl-block">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z"
                                            fill="#000"></path>
                                    </svg>
                                </div>
                                <div class="col-4 col-xl-auto px-xl-0">
                                    <input class="form__control w-160 type_float" @input="checkDimensions()"
                                           @change="checkDimensions()" type="number" v-model="dimensions.height"
                                           id="height" name="height"
                                           :placeholder="get_translation_constant('calculator_block_text_height_cents')"
                                           :disabled="isDisabled"
                                    >
                                </div>
                                <div class="col-auto px-0 d-none d-xl-block">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z"
                                            fill="#000"></path>
                                    </svg>
                                </div>
                                <div class="col-4 col-xl-auto ps-xl-0">
                                    <input class="form__control w-160 type_float" type="number" id="width"
                                           @input="checkDimensions()" @change="checkDimensions()"
                                           v-model="dimensions.width" name="width"
                                           :placeholder="get_translation_constant('calculator_block_text_width_cents')"
                                           :disabled="isDisabled"
                                    >
                                </div>
                                <div class="col-auto px-xl-0 text-right mt-3 mt-xl-0"><strong class="color__gray_1">/6000
                                    = </strong></div>
                                <div class="col-auto h2 mb-0 mt-3 mt-xl-0"><span>{{ calcWeight.value }}</span>
                                    {{ calcWeight.unit }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="extra__services" v-if="!!expanded">
                        <h4 class="h_text_small with__line">
                            <span>{{ get_translation_constant('text_additional_services') }} +</span></h4>

                        <div class="row">
                            <template v-for="(chunkServices, index) in sliceIntoChunks(services, 3)">
                                <div v-for="(service, chunk_index) in chunkServices" class="col-12 col-md-6 col-xl-4">
                                    <div class="checkbox__custom">
                                        <input :id="'checkbox'+( index * 3 + chunk_index)"
                                               :name="'checkbox'+( index * 3 + chunk_index)" type="checkbox"
                                               v-model="local_services[index * 3 + chunk_index].checked">
                                        <label :for="'checkbox'+( index * 3 + chunk_index)">
                                            <span class="tooltip__block tooltip__right tooltip__modal">
                                                <span class="tooltip__block_trigger">
                                                    <img :src="service.icon" class="service-image" alt="">
                                                    <!-- <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                                                         <path d="M10 17c.12 0 .3-.04.49-.13C14.64 14.79 16 13.72 16 11.2V5.92c0-.76-.33-1.01-.98-1.27a118.5 118.5 0 00-4.37-1.55 2.15 2.15 0 00-1.3 0c-.83.26-3.55 1.22-4.38 1.55-.65.25-.97.51-.97 1.27v5.28c0 2.52 1.42 3.47 5.51 5.67.19.1.37.13.49.13zm-.77-3.54c-.26 0-.46-.1-.67-.35l-2.08-2.46a.72.72 0 01-.18-.46c0-.35.28-.6.61-.6.22 0 .4.07.57.28L9.2 12l3.33-5.14c.15-.22.34-.33.54-.33.33 0 .65.22.65.56 0 .15-.1.32-.18.47L9.85 13.1a.72.72 0 01-.62.35z" fill="#2A9C57"/>
                                                     </svg>-->
                                                     &nbsp;{{ service.title }}
                                                    <span v-if="!!service.value">+ {{ service.value }}
                                                        <template v-if="service.as_a_percentage">%</template>
                                                        <template v-else>{{ getCurrencySymbol(service) }}</template>
                                                    </span>
                                                    <span v-else>{{get_translation_constant('text_free')}}</span>
                                               </span>
                                                <span class="tooltip__block_overlay">
                                                    <span class="tooltip__block_inner">
                                                        <span class="tooltip__block_close"></span>
                                                        <p>{{ service.description }}</p>
                                                        <p><a :href="service.link">{{ service.link_info }}</a></p>
                                                    </span>
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div :class="calculatedWrapClass" v-if="!!expanded">
                        <div class="col-12 col-md-6 col-lg-12 col-xl-6 mb-3 mb-xl-0" v-if="!!expanded && validated">
                            <div class="info__alert">
                                {{ get_translation_constant('calculator_block_text_fill_all_sections') }}
                            </div>
                        </div>
                        <div :class="calculatedClass">
                            {{ get_translation_constant('calculator_block_delivery_price') }}
                            <span>{{ calculatedPriceByWeight }}</span>
                        </div>
                    </div>

                </div>
                <div aria-labelledby="product-tab" class="tab-pane fade" id="product" role="tabpanel">
                    <div class="mt-4 mb-4">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="form__col">
                                    <label>{{ get_translation_constant('text_product_category') }}</label>
                                    <multiselect v-model="category"
                                                 :multiple="false"
                                                 :placeholder=" get_translation_constant('text_choose_category')"
                                                 :options="filteredCategories"
                                                 label="name"
                                                 selectLabel=""
                                                 deselectLabel=""
                                                 :optionHeight="48"
                                                 :showPointer="true"
                                                 id="ajax"
                                                 track-by="name"
                                                 open-direction="bottom"
                                                 :searchable="true"
                                                 :loading="isLoading"
                                                 :internal-search="false"
                                                 :clear-on-select="true"
                                                 :close-on-select="true"
                                                 :options-limit="300"
                                                 :limit="10"
                                                 :limit-text="limitText"
                                                 :max-height="600"
                                                 :show-no-results="false"
                                                 :hide-selected="true"
                                                 @search-change="asyncFind"

                                    >
                                        <template></template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form__col">
                                    <label>{{
                                            get_translation_constant('calculator_block_product_country_send')
                                        }}</label>
                                    <multiselect class="selectpicker" v-model="departure_country"
                                                 :multiple="false"
                                                 :placeholder="get_translation_constant('calculator_block_product_choose_country_send')"
                                                 :options="departure_countries"
                                                 label="name"
                                                 selectLabel=""
                                                 deselectLabel=""
                                                 :optionHeight="48"
                                                 :showPointer="true"
                                    >
                                        <template></template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form__col">
                                    <label>{{
                                            get_translation_constant('calculator_block_product_country_arrival')
                                        }}</label>
                                    <multiselect class="selectpicker" v-model="arrival_country"
                                                 :multiple="false"
                                                 :placeholder="get_translation_constant('calculator_block_product_choose_country_arrival')"
                                                 :options="arrival_countries"
                                                 label="name"
                                                 selectLabel=""
                                                 deselectLabel=""
                                                 :optionHeight="48"
                                                 :showPointer="true"
                                    >
                                        <template></template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-12 col-lg-6">
                            <p class="h_text font_semibold">
                                {{ get_translation_constant('calculator_block_product_package_weight') }}:
                                {{ packageWeight }} ( {{ get_translation_constant('calculator_block_volume_weight') }}
                                {{ volumeWeight }}.)</p>
                        </div>
                        <div class="col-12 col-lg-6 total__price d-lg-flex align-items-center justify-content-end">
                            {{ get_translation_constant('calculator_block_delivery_price') }} <span>{{
                                calculatedPrice
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-md-flex justify-content-end">
            <a class="btn btn__medium btn__blue_dark d-block"
               :href="redirectsurl">{{ get_translation_constant('calculator_block_btn_submit') }}</a>
        </div>
    </form>
</template>

<script>
let calc_slider = require("bootstrap-slider");
export default {
    name: "Calculator",
    props: {
        translations: {
            type: [Object, Array]
        },
        arrival_countries: {
            type: [Object, Array]
        },
        departure_countries: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        ratesurl: {
            type: [String]
        },
        redirectsurl: {
            type: [String]
        },
        expanded: {
            type: [Boolean, String],
            default: false
        },
        deliverypricesummary: {
            type: [String]
        },
        services: {
            type: [Object, Array]
        },
        currencies: {
            type: [Object, Array]
        },
    },
    data() {
        return {
            weight: 0.1,
            category_list: [],
            departure_country: {
                id: '',
                name: ''
            },
            arrival_country: {
                id: '',
                name: ''
            },
            country: {
                id: '',
                name: ''
            },
            category: {
                id: '',
                name: ''
            },
            isLoading: false,
            weight_calc: {
                min: 0.1,
                max: 999.9,
                step: 0.1,
                value: 1,
            },
            slide: '',
            local_services: [],
            dimensions: {
                length: '',
                height: '',
                width: ''

            },
            calcBySize: false

        }
    },

    methods: {
        checkDimensions() {
            if (this.dimensions.height < 0) {
                this.dimensions.height = 1;
            }
            if (this.dimensions.length < 0) {
                this.dimensions.length = 1;
            }
            if (this.dimensions.width < 0) {
                this.dimensions.width = 1;
            }
        },
        getCurrencySymbol(service) {
            return '$';
            // return  this.currencies.filter((item) =>{ return item['id'] ===service['currency_id'] })[0]['symbol'] ?? ''
        },
        sliceIntoChunks(arr, chunkSize) {
            const res = [];
            for (let i = 0; i < arr.length; i += chunkSize) {
                const chunk = arr.slice(i, i + chunkSize);
                res.push(chunk);
            }
            return res;
        },
        setSlide() {
            if (this.weight > this.weight_calc.max) {
                this.weight = this.weight_calc.max
            }
            if (this.weight < this.weight_calc.min) {
                this.weight = this.weight_calc.min
            }
            this.slide.setValue(this.weight)
        },
        asyncFind() {

        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        limitText(count) {
            return `and ${count} other categories`
        },
    },

    computed: {
        calculatedWrapClass() {
            if (!!this.expanded) {
                return 'row align-items-center'
            }
            return 'row justify-content-end'

        },
        calculatedClass() {
            if (!!this.expanded) {
                return 'col-12 col-md-6 col-lg-12 col-xl-6 total__price d-md-flex d-lg-block d-xl-flex align-items-center justify-content-end'
            }
            return 'col-12 text-right total__price d-flex align-items-center justify-content-between justify-content-lg-end'
        },
        validated() {
            return true;
        },
        calcWeight() {
            if ((Object.values(this.dimensions).some(elem => elem === '')) || !this.calcBySize) {
                return {
                    value: 0,
                    unit: 'kg'
                }
            }
            return {
                value: (this.dimensions.width * this.dimensions.length * this.dimensions.height / 6000).toFixed(2),
                unit: 'kg'
            }
        },
        volumeWeight() {
            return '2 kg'
        },
        filteredCategories() {
            return this.category_list;
        },
        calculatedPrice() {
            return '9.98$'
        },
        packageWeight() {
            return '6kg';
        },
        calculatedPriceByWeight() {
            let price = 0;
            let weight = 0;

            if (this.calcBySize) {
                if ((Object.values(this.dimensions).some(elem => elem === ''))) {
                    weight = 0;
                } else {
                    weight = (this.dimensions.width * this.dimensions.length * this.dimensions.height / 6000).toFixed(2);
                }


            } else {
                weight = this.weight;
                if (weight < 0.1) {
                    weight = 0.1
                }
            }
            if ((0.1 <= weight) && (weight <= 0.3)) {
                price = 3;
            }
            if (weight <= 3) {
                price = weight * 10;
            }
            if ((3.1 <= weight) && (weight <= 5)) {
                price = weight * 9;
            }
            if (weight > 5) {
                price = weight * 8;
            }

            if (!this.expanded) {
                return price.toFixed(2) + '$';
            }

            //calc extra services
            let percentCoefficient = 0;
            let extraServiceSum = 0;
            this.services.map((item) => {
                if (!!item.checked) {
                    if (!!item.as_a_percentage) {
                        percentCoefficient += item.value;
                    } else {
                        extraServiceSum += item.value;
                    }
                }
            })
            price = price * (1 + percentCoefficient / 100) + extraServiceSum;

            return price.toFixed(2) + '$';
        },
        isDisabled() {
            return !this.calcBySize;
        }
    },
    mounted() {
        const slide = new calc_slider(this.$refs.weight_calc, {
            min: this.weight_calc.min,
            max: this.weight_calc.max,
            step: this.weight_calc.step,
            value: this.weight_calc.value,
        });
        slide.on("change", (slideEvt) => {
            this.weight = slideEvt.newValue == null ? slideEvt.oldValue : slideEvt.newValue;
        });
        this.slide = slide;

    },
    created() {
        this.local_services = this.services;
    }
}
</script>

<style scoped>

</style>
